skrilla.directive('copyToClipboard', function ($window) {
  return {
    restrict: 'E',
    templateUrl: 'directives/copyToClipboard/copyToClipboard.html',
    scope: {
      value: "=",
      title: "=",
      icon: "="
    },
    link: link
  };

  function link(scope) {

    scope.copy = function() {
      const text = scope.value;
      $window.navigator.clipboard.writeText(text).then(
        () => console.log(`Successfully copied '${text}' to clipboard`)
      )
    }
  }
})
